import { Data2, newId, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { CreditPayment, CreditPaymentOperationItem, PaymentOrderStatus } from '../state/types'
import { Currency, TableName } from '../../../tables/types/types'

export const useCreditPaymentBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCreditPayment = (data: Data2) => {
        const {
            id = newId(),
            code,
            paymentTypeId,
            destinationId,
            amount,
            customerId,
            operationItems,
            status,
            creationDate,
            initialDebt,
            initialCredit,
            receiptUrl,
            archived
        } = data

        const creditPayment: CreditPayment = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            paymentTypeId: paymentTypeId as O<string>,
            destinationId: destinationId as O<string>,
            amount: amount! as number,
            customerId: customerId! as string,
            operationItems: (operationItems || []) as CreditPaymentOperationItem[],
            status: (status || PaymentOrderStatus.EMITTED) as PaymentOrderStatus,
            creationDate: dateToString(creationDate || new Date())!,
            initialDebt: initialDebt! as number,
            initialCredit: initialCredit as O<number>,
            currency: Currency.ARS,
            receiptUrl: receiptUrl as O<string>,
            archived: !!archived
        }

        return creditPayment
    }

    const buildCreditPaymentOperationItem = (data: Data2) => {
        const { table, operationId, amount } = data

        const operationItem: CreditPaymentOperationItem = {
            table: table! as TableName,
            operationId: operationId! as string,
            amount: amount! as number
        }

        return operationItem
    }

    return {
        buildCreditPayment,
        buildCreditPaymentOperationItem
    }
}
